import PendingParty from '@pages/gamers/pending-party/pending-party';
export default PendingParty;
